
import {initWebComponent} from "@/helpers/web-component-helper";
import {removeMeasure, startCesiumMeasure} from "@/modules/cesium/cesium-measure";
import {toggleAllowCameraUnderTerrain, toggleShadowMap} from "@/modules/cesium/cesium";
import Slider from "bootstrap-slider";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper.js";
import {initDatePickerSettings} from "@/helpers/date-picker-helper.js";
import $ from "jquery";
import moment from "moment";

const template = document.createElement('template');
template.innerHTML = `
    <div class="row">
        <div class="col-6">
        <label class="switcher mr-1">
    <input type="checkbox" class="switcher-input" id="chbTime">
    <span class="switcher-indicator">
      <span class="switcher-yes">
        <span class="fa fa-draw-polygon"></span>
      </span>
      <span class="switcher-no">
        <span class="fa fa-times"></span>
      </span>
    </span>
    <span class="switcher-label">Schaduw tonen</span>
  </label>
</div>
    <div class="col-6">
        <div class="input-group divTime d-none"  style="margin-top:-5px">
          <span class="input-group-prepend">
            <span class="input-group-text pl-2 pr-2">Datum:</span>
          </span>
          <input id="date" type="text" value="${moment().format('DD-MM-YYYY')}" class="form-control pl-0">
        </div>
    </div>
    </div>
    </div>
    <div class="d-none divTime">
       <input id="time" type="text" data-slider-min="0" data-slider-max="23" data-slider-step="1" data-slider-value="${new Date().getHours()}"/>
    </div>
                `;

export class CesiumToggleShadowComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        initDatePickerSettings()

        $('#date').datepicker({
            format: 'dd-mm-yyyy',
            weekStart: 1,
            language: 'nl',
            orientation: 'bottom',
            autoclose: true,
            clearBtn: false
        }).on('changeDate', function(e) {

        })

        this.addEventListener('click', (e) => {
            if(e.target.type === 'checkbox') {
                const checked = this.querySelector('#chbTime').checked
                toggleShadowMap(checked)

                if(checked) {
                    showElementsBySelector('.divTime')
                } else {
                    hideElementsBySelector('.divTime')
                }
            }
        })

        new Slider('#time', {
            tooltip: 'always',
            tooltip_position: 'bottom',
            formatter: function(value) {
                return '' + value + ':00 uur';
            }
        })
    }
}

